import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faEnvelopeCircleCheck, faFileMedical, faHourglassHalf, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { COLORS } from '../../../constants/colors';

const fmt = (d) => (d ? new Date(d).toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' }) : '');

/** Kit progress for a member row: activated → waiting on results → results sent. */
export const kitStatusFromPatient = (patient) => {
  const kit = patient?.endlessActivation || {};
  if (!kit.activatedAt) return null;
  const sentAt = [kit.resultsEmailSentAt, kit.resultsSmsSentAt].filter(Boolean).sort().pop() || null;
  return {
    activatedAt: kit.activatedAt,
    rejectedAt: kit.rejectedAt || null,
    resultsReadyAt: kit.resultsReadyAt || null,
    sentAt,
    sentVia: [kit.resultsEmailSentAt && 'email', kit.resultsSmsSentAt && 'text'].filter(Boolean).join(' and ')
  };
};

const icon = (title, fa, color) => (
  <Tooltip title={title}>
    <span style={{ color, display: 'inline-flex' }} onClick={(e) => e.stopPropagation()}>
      <FontAwesomeIcon icon={fa} />
    </span>
  </Tooltip>
);

const KitStatusIcons = ({ status }) => {
  if (!status) return null;
  let second;
  if (status.rejectedAt && !status.resultsReadyAt) {
    second = icon(`Sample rejected by the lab ${fmt(status.rejectedAt)}`, faTriangleExclamation, COLORS.warningAmber);
  } else if (!status.resultsReadyAt) {
    second = icon('Pending results', faHourglassHalf, COLORS.textLight);
  } else if (status.sentAt) {
    second = icon(`Results ready ${fmt(status.resultsReadyAt)} · member notified by ${status.sentVia} ${fmt(status.sentAt)}`, faEnvelopeCircleCheck, COLORS.$deepTiffany);
  } else {
    second = icon(`Results ready ${fmt(status.resultsReadyAt)} · member not notified yet`, faFileMedical, COLORS.$deepTiffany);
  }
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginLeft: 8, fontSize: 13 }}>
      {icon(`Kit activated ${fmt(status.activatedAt)}`, faCircleCheck, COLORS.$deepTiffany)}
      {second}
    </span>
  );
};

export default KitStatusIcons;
